import { render, staticRenderFns } from "./AppAsideCart.vue?vue&type=template&id=94046ae0&scoped=true"
import script from "./AppAsideCart.vue?vue&type=script&lang=ts"
export * from "./AppAsideCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94046ae0",
  null
  
)

export default component.exports